import { render, staticRenderFns } from "./VcaTable.vue?vue&type=template&id=4590f3b6"
import script from "./VcaTable.vue?vue&type=script&lang=js"
export * from "./VcaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports